// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Isolation Units API
 * Manage isolation units, clusters and partitions.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface Partition
 */
export interface Partition {
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof Partition
   */
  annotations?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof Partition
   */
  cloudProvider?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof Partition
   */
  clusters?: Array<string>;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof Partition
   */
  labels?: { [key: string]: string };
  /**
   *
   * @type {string}
   * @memberof Partition
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof Partition
   */
  partitionAlias?: string;
  /**
   *
   * @type {string}
   * @memberof Partition
   */
  plane?: string;
  /**
   *
   * @type {string}
   * @memberof Partition
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof Partition
   */
  scope?: string;
}

/**
 * Check if a given object implements the Partition interface.
 */
export function instanceOfPartition(value: object): value is Partition {
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function PartitionFromJSON(json: any): Partition {
  return PartitionFromJSONTyped(json, false);
}

export function PartitionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Partition {
  if (json == null) {
    return json;
  }
  return {
    annotations: json['annotations'] == null ? undefined : json['annotations'],
    cloudProvider:
      json['cloud_provider'] == null ? undefined : json['cloud_provider'],
    clusters: json['clusters'] == null ? undefined : json['clusters'],
    labels: json['labels'] == null ? undefined : json['labels'],
    name: json['name'],
    partitionAlias:
      json['partition_alias'] == null ? undefined : json['partition_alias'],
    plane: json['plane'] == null ? undefined : json['plane'],
    region: json['region'] == null ? undefined : json['region'],
    scope: json['scope'] == null ? undefined : json['scope'],
  };
}

export function PartitionToJSON(json: any): Partition {
  return PartitionToJSONTyped(json, false);
}

export function PartitionToJSONTyped(
  value?: Partition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    annotations: value['annotations'],
    cloud_provider: value['cloudProvider'],
    clusters: value['clusters'],
    labels: value['labels'],
    name: value['name'],
    partition_alias: value['partitionAlias'],
    plane: value['plane'],
    region: value['region'],
    scope: value['scope'],
  };
}
